import { CongesDashboardView } from "@features/home-dashboard/conges";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/conges/me/")({
  staticData: {
    title: "Mes Congés",
    section: "Général",
    order: 30,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: CongesMeRoute,
});

function CongesMeRoute() {
  return <CongesDashboardView />;
}
